import React from "react";
import { Link } from "react-router-dom";
import { Layout } from "../components/tag/Layout";
import { HeroBg, EyebrowPill } from "../components/tag/Primitives";
import { SHOP_LIST } from "../data/shop";

export default function Shop() {
  return (
    <Layout title="Shop | The Authority Gap" path="/shop">
      <section style={{ background: "#090909", padding: "70px 32px 50px", position: "relative", overflow: "hidden", textAlign: "center" }}>
        <HeroBg />
        <div style={{ position: "relative", zIndex: 1, maxWidth: 820, margin: "0 auto" }}>
          <div style={{ marginBottom: 20 }}><EyebrowPill>The Shop · $19 each</EyebrowPill></div>
          <h1 className="tag-h1" style={{ marginBottom: 14 }}>Frameworks you can use this week.</h1>
          <p style={{ color: "#aaa", fontSize: 15, lineHeight: 1.7 }}>
            Four short, dense PDFs distilled from the AuthorityOS labs. One-time payment, instant download, lifetime access.
          </p>
        </div>
      </section>

      <section style={{ background: "#090909", borderTop: "1px solid #1a1a1a", padding: "30px 20px 100px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 18 }}>
          {SHOP_LIST.map((p) => (
            <Link
              key={p.slug}
              to={`/shop/${p.slug}`}
              data-testid={`shop-card-${p.slug}`}
              className="tag-card"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 12,
                textDecoration: "none",
                borderTop: `2px solid ${p.accent}`,
                transition: "transform .15s ease, border-color .15s ease",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                <span style={{
                  background: `${p.accent}22`, color: p.accent, fontSize: 10, fontWeight: 700,
                  textTransform: "uppercase", letterSpacing: "0.08em", padding: "3px 8px", borderRadius: 4,
                }}>{p.type}</span>
                <span style={{ color: "#fff", fontSize: 18, fontWeight: 700 }}>{p.priceLabel}</span>
              </div>
              <h3 style={{ color: "#fff", fontSize: 17, fontWeight: 700, margin: 0, lineHeight: 1.3 }}>{p.name}</h3>
              <p style={{ color: "#aaa", fontSize: 13, lineHeight: 1.6, margin: 0, flex: 1 }}>{p.blurb}</p>
              <div style={{ color: "#777", fontSize: 11, marginTop: "auto" }}>{p.pages} pages · PDF</div>
              <span className="btn-ghost" style={{ textAlign: "center", fontSize: 12 }}>{p.cta}</span>
            </Link>
          ))}
        </div>
      </section>
    </Layout>
  );
}
